<template>
    <div>
      <div class="card">
        <div class="card card-custom" >
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label">{{ $t('setting.signature.list') }}</h3>
            </div>
            <div class="card-toolbar" >
              <Button btn-class="btn-sm" type="new" btn-text="setting.signature.new" @click="openCreateModal"/>
            </div>
          </div>
  
          <div class="card-body">
            <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" style="margin-top: 13px !important; cursor:pointer">
              <thead>
                <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                  <th> {{$t("setting.signature.title")}}</th>
                  <th class="w-100px">{{$t("actions")}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="signatures?.length > 0" v-for="(signature, index) in signatures" :key="index">
                  <td>
                    {{ signature.name }} <span v-if="signature.enabled" class="ms-5 badge badge-light-primary">{{ $t('default') }}</span>
                  </td>
                  <td>
                    <i class="fas fa-edit fs-2 me-5" @click="editSignature(signature)" :title="$t('button.edit')" :style="{color: Theme.gray}" ></i>
                    <i class="fas fa-trash fs-2" @click="deleteSignature(signature.id)" :title="$t('button.delete')" :style="{color: Theme.gray}" ></i>
                  </td>
                </tr>
                <tr v-else class="text-center justify-content-center">
                  <td colspan="2">
                    <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <SignatureModal id="kt_modal_create_signature" @load="loadData"/>
    <SignatureModal id="kt_modal_edit_signature" @load="loadData" :edit="true" :form="formEdit"/>
  </template>

  <script setup>
  import { useI18n } from 'vue-i18n'
  import {useStore} from "vuex";
  import { onMounted, ref, computed} from "vue"
  import Button from "@/components/Button.vue"
  import {useSwal} from "@/composables/useSwal";
  import {Theme} from "@/composables/theming";
  import SignatureModal from '../../Mail/components/Modals/SignatureModal.vue';

  const {showSwal} = useSwal()
  const { t } = useI18n({ useScope: 'global' })

  const formEdit = ref({
    id: '',
    name: '',
    content: '',
    enabled: false
  })

  const store = useStore()

  const signatures = computed(() => store.getters['mails/getSignatures'])

  function loadData() {
    store.dispatch('mails/loadSignatures')
  }

  onMounted(() => {
    loadData()
  })

  function openCreateModal(){
    $('#kt_modal_create_signature').modal('toggle')
  }

  function editSignature(signature) {
    formEdit.value.id = signature.id
    formEdit.value.name = signature.name
    formEdit.value.content = signature.content
    formEdit.value.enabled = signature.enabled

    $('#kt_modal_edit_signature').modal('toggle')
  }
  
  async function deleteSignature(id){
    showSwal(
        '',
        i18n.global.t('swal.signature_deleting')
    ).then( async (result) => {
        if (result.value) {
          try {
            await store.dispatch('mails/deleteSignature', id)
            loadData()
            window.toastr.success(t('notification.signature_deleted_successfully'))
          }catch (e) {
          }
        }
    })
  }

  </script>
  